import React, { useEffect, useState } from "react";
import "../../main-component/CaptainTCCards/CaptainTCCards.css";
import promoImg1 from "../../images/captain-tc/CaptainTCCollecableGeneis10-1.jpg";
import card25Img from "../../images/captain-tc/25PoundCard.jpg";
import coinImg from "../../images/captain-tc/coin.png";
import {
  FaWallet,
  FaCoins,
  FaShoppingBag,
  FaPuzzlePiece,
  FaGift,
  FaInfoCircle,
  FaStar,
} from "react-icons/fa";
import { API_URL } from "../../constant";

const ImageMagnifier = ({ src, alt }) => {
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [position, setPosition] = useState({ x: 50, y: 50 });

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setPosition({ x, y });
  };

  return (
    <div
      onMouseEnter={() => setShowMagnifier(true)}
      onMouseLeave={() => setShowMagnifier(false)}
      onMouseMove={handleMouseMove}
      style={{
        position: "relative",
        overflow: "hidden",
        width: "180px",
        height: "240px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
        cursor: "pointer",
        transform: showMagnifier ? "scale(1.8)" : "scale(1)",
        zIndex: showMagnifier ? 20 : 1,
        transition: "transform 0.2s ease-out"
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          transform: showMagnifier ? "scale(1.8)" : "scale(1)",
          transformOrigin: `${position.x}% ${position.y}%`,
          transition: showMagnifier ? "transform 0.1s ease-out" : "transform 0.3s ease-out",
          pointerEvents: "none"
        }}
      />
    </div>
  );
};

const CaptainTCCardsContent = () => {
  const [publicProducts, setPublicProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function fetchProducts() {
      try {
        const response = await fetch(`${API_URL}/api/public-products`, {
          headers: { Accept: "application/json" },
        });
        if (!response.ok) return;
        const data = await response.json();
        if (!cancelled && data.products) {
          setPublicProducts([...data.products].reverse());
        }
      } catch (error) {
        console.warn("Public products unavailable:", error.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    fetchProducts();
    return () => {
      cancelled = true;
    };
  }, []);

  const cardOptions = publicProducts.map((product) => ({
    title: product.name,
    amount_label: Number(product.price).toFixed(2),
    purchaseReward: product.short_description || "",
    reward: product.description
      ? product.description.replace(/<[^>]*>?/gm, "")
      : "",
    limit: "",
    serial: product.sku || "N/A",
    image: product.thumbnail_url
      ? `${API_URL}${product.thumbnail_url}`
      : card25Img,
  }));

  return (
    <div className="captain-tc-content">
      <section className="captain-tc-intro-section">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            alignItems: "center",
            marginBottom: "40px",
          }}
        >
          <img
            src={promoImg1}
            alt="Captain TC Promo 1"
            style={{
              maxWidth: "80%",
              height: "auto",
              borderRadius: "10px",
            }}
          />
          <div className="captain-tc-product-tiers mt-4 mb-4">
            {cardOptions.map((card) => (
              <div key={card.title} className="captain-tc-product-card">
                <div
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div className="product-card-image">
                    <ImageMagnifier src={card.image} alt={card.title} />
                  </div>
                </div>
                <h3
                  className="product-card-title mb-0"
                  style={{ textAlign: "left" }}
                >
                  {card.title}
                </h3>
              </div>
            ))}
          </div>

          <div className="captain-tc-infographic">
            <div className="infographic-header">
              <div className="gold-line"></div>
              <h2>5 REASONS TO OWN A CAPTAIN TC GOLD REWARDS CARD</h2>
              <div className="gold-line"></div>
            </div>

            <div className="infographic-body">
              <div className="infographic-left">
                {[
                  {
                    icon: <FaWallet />,
                    text: "Every TopCoin you earn is automatically credited to both your TopCoin Wallet and your Captain TC Gold Rewards Wallet, allowing you to unlock <span class='gold-text'>exclusive gold rewards</span> as your balance grows.",
                  },
                  {
                    icon: <FaCoins />,
                    text: "Complete: on every <span class='gold-text'>250</span> TopCoin you'll collect half of the price of the card you purchased - for <span class='gold-text'>20</span> times till you reach <span class='gold-text'>5000</span> TopCoin.",
                  },
                  {
                    icon: <FaShoppingBag />,
                    text: "On TopCoin Land Ltd with the special products receive <span class='gold-text'>mystery Captain TC Gold TopCoin</span> gold coin.",
                  },
                  {
                    icon: <FaPuzzlePiece />,
                    text: "You can intercept the <span class='gold-text'>collectible gold TopCoin</span> and complete it.",
                  },
                  {
                    icon: <FaGift />,
                    text: "As you finish the 5000 TopCoin on your card you'll <span class='gold-text'>receive the amount you purchase</span> your card in gold Captain TC Gold TopCoin.",
                  },
                ].map((item, index) => (
                  <div key={index} className="infographic-list-item">
                    <div
                      className="info-number"
                      style={{
                        fontSize: "1.2rem",
                        minWidth: "30px",
                        height: "30px",
                      }}
                    >
                      {index + 1}
                    </div>
                    <div className="info-icon">{item.icon}</div>
                    <div
                      className="info-text"
                      style={{
                        marginTop: "0px",
                        textAlign: "top",
                        marginBottom: "0px",
                        fontSize: "0.8rem",
                      }}
                      dangerouslySetInnerHTML={{ __html: item.text }}
                    ></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="captain-tc-infographic">
          <div className="infographic-right">
            <div className="info-right-box top-box">
              <h4 className="gold-text">COMPLETE ON EVERY 250 TOPCOIN</h4>
              <div className="info-flow">
                <div className="flow-circle" style={{ fontSize: "0.7rem" }}>
                  250
                  <br />
                  TOPCOIN
                </div>
                <div className="flow-dash"></div>
                <div
                  className="flow-circle text-gold"
                  style={{ fontSize: "0.7rem" }}
                >
                  HALF
                  <br />
                  CARD
                  <br />
                  VALUE
                </div>
                <div className="flow-dash"></div>
                <div className="flow-circle" style={{ fontSize: "0.7rem" }}>
                  500
                  <br />
                  TOPCOIN
                </div>
                <div className="flow-dash"></div>
                <div
                  className="flow-circle text-gold"
                  style={{ fontSize: "0.7rem" }}
                >
                  HALF
                  <br />
                  CARD
                  <br />
                  VALUE
                </div>
                <div className="flow-dash"></div>
                <div className="flow-circle" style={{ fontSize: "0.7rem" }}>
                  750
                  <br />
                  TOPCOIN
                </div>
                <div className="flow-dash"></div>
                <div
                  className="flow-circle text-gold"
                  style={{ fontSize: "0.7rem" }}
                >
                  HALF
                  <br />
                  CARD
                  <br />
                  VALUE
                </div>
                <div className="flow-dash"></div>
                <div className="flow-circle" style={{ fontSize: "0.7rem" }}>
                  5000
                  <br />
                  TOPCOIN
                  <br />
                  VALUE
                </div>
              </div>
              <p className="flow-footer" style={{ color: "#d4af37" }}>
                FOR 20 TIMES TILL YOU REACH 5000 TOPCOIN
              </p>
            </div>
          </div>
        </div>

        <div className="captain-tc-infographic">
          <div className="infographic-right">
            <div className="info-right-box bottom-box">
              <div className="stars">
                <FaStar className="gold-text" />{" "}
                <FaStar className="gold-text" />{" "}
                <FaStar className="gold-text" />
                <span className="gold-text">FINISH 5000 TOPCOIN</span>
                <FaStar className="gold-text" />{" "}
                <FaStar className="gold-text" />{" "}
                <FaStar className="gold-text" />
              </div>
              <p className="receive-text gold-text">
                RECEIVE BACK THE FULL VALUE
                <br />
                OF YOUR CARD IN GOLD
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "15px",
                  marginTop: "10px",
                }}
              >
                <h3
                  className="gold-text large-gold"
                  style={{ textAlign: "left", margin: 0 }}
                >
                  CAPTAIN TC
                  <br />
                  GOLD TOPCOIN
                </h3>
                <img
                  src={coinImg}
                  alt="Captain TC Gold Coin"
                  style={{
                    width: "120px",
                    height: "auto",
                    objectFit: "contain",
                    filter: "drop-shadow(0 5px 15px rgba(212, 175, 55, 0.4))",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="captain-tc-infographic">
          <div
            className="infographic-footer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              borderTop: "0px solid #ccc",
            }}
          >
            <div className="footer-info">
              <FaInfoCircle className="info-circle-icon" />
              <div>
                <p>FOR MORE INFORMATION</p>
                <p className="gold-text">GO TO CAPTAIN TC CARD</p>
              </div>
            </div>
            <img
              src={coinImg}
              alt="Small Captain TC Gold Coin"
              style={{ width: "60px", height: "auto", objectFit: "contain" }}
            />
            <div className="footer-tagline">
              <h3 className="gold-text">
                UNLOCK VALUE. EARN GOLD. BUILD LEGACY.
              </h3>
              <p>WWW.TOPCOINUK.COM</p>
            </div>
          </div>
        </div>

        <div
          className="captain-tc-cta-wrapper"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{ marginTop: "30px", textAlign: "center", color: "black" }}
          >
            <p
              style={{
                fontWeight: "bold",
                fontSize: "1.1rem",
                marginBottom: "8px",
                color: "#CCCEEF",
              }}
            >
              Exclusively for TCUK Customers
            </p>
            <p
              style={{
                fontSize: "0.95rem",
                marginBottom: "30px",
                maxWidth: "700px",
                color: "#CCCEEF",
              }}
            >
              Please note, if you are already TCUK members, please become as a
              TCUK customer
            </p>
            <a
              href="https://staging.topcoinuk.com/sign_in"
              style={{
                textDecoration: "underline",
                display: "inline-block",
                color: "#0d6efd",
                marginBottom: "40px",
                fontWeight: "bold",
              }}
            >
              https://staging.topcoinuk.com/sign_in
            </a>
          </div>
          <button
            onClick={() => {
              const width = 1000;
              const height = 750;
              const left = window.screenX + (window.outerWidth - width) / 2;
              const top = window.screenY + (window.outerHeight - height) / 2;
              window.open(
                "https://stagingcollectible.topcoinuk.com/purchase/",
                "purchaseWindow",
                `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
              );
            }}
            className="captain-tc-cta"
            style={{
              textDecoration: "none",
              display: "inline-block",
              cursor: "pointer",
              border: "none",
            }}
          >
            PURCHASE NOW
          </button>
        </div>
      </section>
    </div>
  );
};

export default CaptainTCCardsContent;
